import { render } from "./PlotlyChartsComponent.vue?vue&type=template&id=6549a873&scoped=true"
import script from "./PlotlyChartsComponent.vue?vue&type=script&lang=js"
export * from "./PlotlyChartsComponent.vue?vue&type=script&lang=js"

import "./PlotlyChartsComponent.vue?vue&type=style&index=0&id=6549a873&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6549a873"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon});
